<template>
  <div class="chart-card">
    <div class="chart-card__header">
      <div>
        <h3 class="chart-card__title">{{ title }}</h3>
        <p class="chart-card__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="chart-card__body">
      <div v-if="!hasData" class="chart-card__empty">
        <font-awesome-icon icon="layer-group" class="chart-card__empty-icon" />
        <p>Ingen data tilgjengelig</p>
      </div>
      <apexchart
        v-else
        type="treemap"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'CategoryPerformanceChart',
  components: { apexchart: VueApexCharts },
  props: {
    title: { type: String, default: 'Kategoriytelse' },
    subtitle: { type: String, default: 'Omsetning per kategori' },
    categories: { type: Array, default: () => [] },
    height: { type: Number, default: 300 }
  },
  computed: {
    hasData() {
      return this.categories && this.categories.length > 0;
    },
    series() {
      return [{
        data: this.categories.map(cat => ({
          x: cat.name,
          y: cat.revenue
        }))
      }];
    },
    chartOptions() {
      return {
        chart: {
          type: 'treemap',
          toolbar: { show: false },
          fontFamily: 'inherit'
        },
        legend: { show: false },
        colors: ['#B30E10', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#DDA0DD', '#F0E68C', '#87CEEB'],
        plotOptions: {
          treemap: {
            distributed: true,
            enableShades: false,
            dataLabels: {
              format: 'truncate'
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',
            fontWeight: 600
          },
          formatter: function(text, op) {
            const value = op.value;
            const formatted = value >= 1000
              ? (value / 1000).toFixed(0) + 'k'
              : value;
            return [text, formatted + ' kr'];
          },
          offsetY: -4
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return new Intl.NumberFormat('nb-NO').format(Math.round(val)) + ' kr';
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-card {
  background: var(--bo-surface);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.chart-card__header {
  padding: 20px 20px 0 20px;
}

.chart-card__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--bo-ink);
  margin: 0 0 4px 0;
}

.chart-card__subtitle {
  font-size: 13px;
  color: var(--bo-muted);
  margin: 0;
}

.chart-card__body {
  padding: 16px 20px 20px;
}

.chart-card__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--bo-muted-2);
}

.chart-card__empty-icon {
  font-size: 32px;
  margin-bottom: 12px;
}
</style>
